export default __webpack_public_path__ + "static/index-sample-03-7d8c3043250f09d274b23ac17c335da1.jpg";